(function () {
  function initProductShowcase(section) {
    const track = section.querySelector('[data-ff-product-track]');
    const prevBtn = section.querySelector('[data-ff-product-prev]');
    const nextBtn = section.querySelector('[data-ff-product-next]');

    if (!track || !prevBtn || !nextBtn) return;

    const scrollStep = () => {
      const item = track.querySelector('.ff-product-showcase__item');
      if (!item) return track.clientWidth * 0.85;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return item.offsetWidth + gap;
    };

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
    });
  }

  function initAll() {
    document.querySelectorAll('.ff-product-showcase').forEach(initProductShowcase);

    document.querySelectorAll('.ff-product-showcase product-recommendations').forEach((el) => {
      if (el.dataset.ffRecsObserved === 'true') return;
      el.dataset.ffRecsObserved = 'true';

      const observer = new MutationObserver(() => {
        const section = el.closest('.ff-product-showcase');
        if (section) initProductShowcase(section);
      });

      observer.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.ff-product-showcase') || event.target;
    if (section && section.classList.contains('ff-product-showcase')) {
      initProductShowcase(section);
    }
  });
})();
